import cn from 'classnames';
import Image from 'next/image';
import { FC } from 'react';

import { LockOutlined } from '@ant-design/icons';

import { LoyaltyBenefit } from '~types';

import styles from './BenefitsTable.module.css';

export interface BenefitsProps {
  title: string;
  subtitle?: string;
  locked?: boolean;
  data: LoyaltyBenefit[];
  level?: string;
}

const BenefitsTable: FC<BenefitsProps> = ({ title, subtitle, data, locked, level }) => {
  return (
    <table className={cn(styles.root, { [styles.locked]: locked })}>
      <thead>
        <tr>
          <th
            colSpan={2}
            className={`${styles.head} ${level === '2' && styles.headLevel2} ${
              level === '3' && styles.headLevel3
            }`}
          >
            {locked && (
              <span>
                <LockOutlined />
              </span>
            )}
            <h3 className={styles.headTitle}>{title}</h3>
            {subtitle && <p className={styles.headSubtitle}>{subtitle}</p>}
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr key={item.id}>
            <td className={styles.cell}>
              <div className={styles.cellWrap}>
                <span className={styles.cellImg}>
                  <Image
                    src={item.icon.url}
                    width={40}
                    height={40}
                    className="object-cover"
                    alt={`Icono del beneficio ${item.title}`}
                  />
                </span>
                <div>
                  <h4 className={styles.cellTitle}>{item.title}</h4>
                  <div
                    className={styles.cellContent}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BenefitsTable;
